export default "__VITE_PUBLIC_ASSET__405816b5__"